import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PagerService } from 'kinetic-angular';
import { Icons } from '../../../services/shared/shared-enums';
import { Content } from '../definitions';
import { NotificationService } from '../notification.service';
import { SharedService } from '../../../services/shared/shared.service';


@Component({
	selector: 'tmhna-portal-notification-content',
	templateUrl: './notification-content.component.html',
	styleUrls: ['./notification-content.component.scss']
})
export class NotificationContentComponent
{
	@Input() state!: Array<Content>;
	@Input() currentPage: number = 1;
	@Input()
		totalItems!: number;
	@Input() tabName: string = '';
	@Input() pageSize!: number;

	@Output() notificationId: EventEmitter<string> =

		new EventEmitter<string>();

	closeIcon = Icons.closePng;
	isNewIcon = Icons.greenDot;
	notificationIcon = Icons.notificationoffer;
	activeIcon = this.sharedService.isRaymond ? Icons.raymondUpdateIcon: Icons.actionIcon;
	actionIcon = this.sharedService.isRaymond ? Icons.raymondActionIcon: Icons.actionIcon;
	statusChangedIcon = Icons.notificationInbox;
	
	component!: Content;
	constructor(
		private readonly router: Router,
		public notificationService: NotificationService,
		public pagerService: PagerService,
		private readonly sharedService: SharedService
		
	) { }

	public navigation(i:number)

	{
		this.sharedService.navigateMethod(this.router, this.state[i].notificationLink);

	}

	deleteNotification(id: string) 
	{
		if(id) 
		{
			this.notificationId.emit(id);
		}
			
	}

	downloadReport(data: string | undefined)
	{
		this.notificationService.downloadReport(data);		
	}
}


